import LookUpTableAPI from '../../Admin/Services/LookUpTableAPI';
import LookUpTableModel from '../../Admin/model/LookUpTableModel';
import LookUpDetailModel from '../../Admin/model/LookUpDetailModel';

class LookUpService {

    lookUpTableAPI: LookUpTableAPI = new LookUpTableAPI();
    getLookUpTables = async (): Promise<LookUpTableModel[]> => {
        return await this.lookUpTableAPI.getLookUpTables();
    }

    getLookUpDetail = async (tableId: string): Promise<LookUpDetailModel[]> => {
        return await this.lookUpTableAPI.getLookUpDetail(tableId);
    }

    deleteLookUpDetail = async (lookUpId: string): Promise<boolean> => {
        return await this.lookUpTableAPI.deleteLookUpDetail(lookUpId);
    }

    saveLookUpDetail = async (model: LookUpDetailModel) => {
        return await this.lookUpTableAPI.saveLookUpDetail(model);
    }

    updateLookUpDetail = async (model: LookUpDetailModel) => {
        return await this.lookUpTableAPI.updateLookUpDetail(model);
    }

    reloadLookupDetailsToCache = async (tableId: string) => {
        return await this.lookUpTableAPI.reloadLookupDetailsToCache(tableId);
    }
}
export default LookUpService;